import LeonidaPrenotazioneList from "./components/LeonidaPrenotazioneList.vue";
import LeonidaPrenotazioneEdit from "./components/LeonidaPrenotazioneEdit";
import LeonidaPrenotazioneView from "./components/LeonidaPrenotazioneView.vue";

export default {
    LeonidaPrenotazioneList,
    LeonidaPrenotazioneEdit,
    LeonidaPrenotazioneView,
};
